import { createSelector } from '@ngrx/store';

import { hasAnonymization } from '@collections/users';
import { CandidateAdapter, CandidateFormAdapter } from '@shared/models';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { candidatesAdapter, CandidatesState } from './candidates.reducer';

export const getCandidatesState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.candidates,
);

export const {
  selectIds: getCandidatesIds,
  selectEntities: getCandidatesEntities,
  selectAll: getCandidatesAll,
  selectTotal: getCandidatesTotal,
} = candidatesAdapter.getSelectors(getCandidatesState);

export const getCandidatesNotLoaded = createSelector(
  getCandidatesState,
  (state: CandidatesState) => !!state && !state.loaded,
);

export const getCandidatesSelectedId = createSelector(
  getCandidatesState,
  (state: CandidatesState) => !!state && +state.selectedId,
);

export const CandidateSelectedObj = {
  getCandidatesSelected: (anonymize?: boolean) =>
    createSelector(
      getCandidatesEntities,
      getCandidatesSelectedId,
      hasAnonymization,
      (entities, selectedId, anonymization: boolean) =>
        !!selectedId &&
        !!entities &&
        Object.keys(entities).length > 0 &&
        new CandidateAdapter({ ...entities[selectedId] }, !!anonymize && anonymization),
    ),
};

export const getCandidateForm = createSelector(getCandidatesEntities, (entities, props) =>
  !!entities && props.id
    ? new CandidateFormAdapter(entities[props.id])
    : ({} as CandidateFormAdapter),
);

export const getCandidate = (id) =>
  createSelector(
    getCandidatesEntities,
    (entities) => !!entities && new CandidateAdapter(entities[id]),
  );

export const getCountCandidates = createSelector(
  getCandidatesState,
  (state: CandidatesState) =>
    !!state && !!state.totalCandidatesShortlist && state.totalCandidatesShortlist,
);
